import React, { useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Button, Col, Input, Label, Row, Table } from "reactstrap";
import ExportJsonExcel from "js-export-excel";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";

const headers = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });
const fmtN = (v) => new Intl.NumberFormat("es-MX").format(v || 0);

function ListadoPendRecibir() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const [filas, setFilas] = useState([]);
  const [buscar, setBuscar] = useState("");
  const [proveedor, setProveedor] = useState("");

  useEffect(() => {
    axios.get(`${URL_ARTICULOS_OC}/PendRecibir`, { headers: headers() })
      .then((r) => setFilas(r.data))
      .catch(console.log);
  }, [URL_ARTICULOS_OC]);

  const proveedores = useMemo(() => [...new Set(filas.map((f) => f.proveedor))].sort(), [filas]);
  const visibles = useMemo(() => {
    const q = buscar.toLowerCase();
    return filas.filter((f) =>
      (!proveedor || f.proveedor === proveedor) &&
      (!q || `${f.codigo} ${f.nombre} ${f.idOrdenCompra}`.toLowerCase().includes(q)));
  }, [filas, buscar, proveedor]);
  const total = visibles.reduce((t, f) => t + f.pendiente_recibir, 0);

  const excel = () => {
    const toExcel = new ExportJsonExcel({
      fileName: "PendienteRecibir",
      datas: [{
        sheetData: visibles.map((f) => ({ OC: f.idOrdenCompra, Proveedor: f.proveedor, Codigo: f.codigo, Vino: f.nombre, Compromiso: f.fecha_compromiso, Pedido: f.cantidad, Recibido: f.recibido, Pendiente: f.pendiente_recibir })),
        sheetName: "Pendiente",
        sheetFilter: ["OC", "Proveedor", "Codigo", "Vino", "Compromiso", "Pedido", "Recibido", "Pendiente"],
        sheetHeader: ["OC", "Proveedor", "Codigo", "Vino", "Compromiso", "Pedido", "Recibido", "Pendiente"],
      }],
    });
    toExcel.saveExcel();
  };

  if (!user.pendiente_recibir) return <Header />;

  return (
    <>
      <Header />
      <div className="card container col-12">
        <div className="page-header">
          <div>
            <h3 className="page-title">Pendiente por recibir</h3>
            <p className="page-subtitle">{fmtN(total)} botellas en órdenes de compra abiertas</p>
          </div>
          {user.exportar ? <Button size="sm" color="primary" onClick={excel}>Exportar Excel</Button> : null}
        </div>
        <Row className="filter-row">
          <Col md={4}>
            <Label>Buscar</Label>
            <Input value={buscar} onChange={(e) => setBuscar(e.target.value)} placeholder="Vino, código u orden" />
          </Col>
          <Col md={4}>
            <Label>Proveedor</Label>
            <Input type="select" value={proveedor} onChange={(e) => setProveedor(e.target.value)}>
              <option value="">Todos</option>
              {proveedores.map((p) => <option key={p} value={p}>{p}</option>)}
            </Input>
          </Col>
        </Row>
        <Table size="sm" responsive className="mt-3">
          <thead>
            <tr>
              <th>OC</th><th>Proveedor</th><th>Vino</th><th>Compromiso</th>
              <th className="text-right">Pedido</th><th className="text-right">Recibido</th>
              <th className="text-right">Pendiente</th><th></th>
            </tr>
          </thead>
          <tbody>
            {visibles.map((f) => (
              <tr key={f.id}>
                <td>{f.idOrdenCompra}</td>
                <td>{f.proveedor}</td>
                <td>{f.codigo} {f.nombre}</td>
                <td>{f.fecha_compromiso}</td>
                <td className="text-right">{fmtN(f.cantidad)}</td>
                <td className="text-right">{fmtN(f.recibido)}</td>
                <td className="text-right negrita">{fmtN(f.pendiente_recibir)}</td>
                <td className="text-right">
                  {user.compras_create ? <a className="btn btn-sm btn-primary" href={`/ComprasCreate?oc=${f.idOC}`}>Recibir</a> : null}
                </td>
              </tr>
            ))}
            {visibles.length === 0 && <tr><td colSpan={8} className="text-center">Sin pendientes por recibir</td></tr>}
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default ListadoPendRecibir;
